import { endPoints, requestType } from "../lib/variable";
import Api from "./index";
const getAllCategory = () => {
  return Api(endPoints.getCategory, null, requestType.GET);
};
const createCategory = (payload) => {
  return Api(endPoints.createCategory, payload, requestType.POST);
};
const updateCategory = (id, payload) => {
  return Api(`${endPoints.updateCategory}/${id}`, payload, requestType.POST);
};
const deleteCategory = (id, payload) => {
  return Api(`${endPoints.deleteCategory}/${id}`, payload, requestType.DELETE);
};

export { getAllCategory, createCategory, updateCategory, deleteCategory };
